import wl_look_popup from './wl_look_popup.vue';

wl_look_popup.install = function (Vue) {
    Vue.component(wl_look_popup.name, wl_look_popup);
};

export default wl_look_popup;